/* Bundle-only tools (DateMaker, PictureMaker, SurveyMaker) – see docs/features/bundle-tools-handoff.md
 *
 * From 30 September 2026 (UK time; planned for 1 October, launched a day
 * early) DateMaker and PictureMaker are part of the
 * Easy Read Bundle only. ps_shopify's /valid/<customer_id> tells us whether
 * the account holder holds a valid Bundle licence as `bundle_tools`. Until
 * ps_shopify deploys that change the field is absent, and we then behave
 * exactly as before.
 */
(function (root) {
  var BundleTools = {
    // Midnight at the start of 30 September 2026, Europe/London (BST, UTC+1),
    // so the live store switches as soon as the theme is published.
    CUTOVER: new Date(Date.UTC(2026, 8, 29, 23, 0, 0)),

    // The test store always behaves as if the cutover has passed, so the new
    // product lines can be tried out there before launch. The live store waits.
    TEST_STORE: 'my-test-shop-5.myshopify.com',

    currentShop: function () {
      return root.Shopify && root.Shopify.shop;
    },

    cutoverPassed: function (now, shop) {
      if ((shop || BundleTools.currentShop()) === BundleTools.TEST_STORE) return true;
      return (now || new Date()) >= BundleTools.CUTOVER;
    },

    hasFlag: function (data) {
      return !!data && typeof data.bundle_tools === 'boolean';
    },

    // Appended to the Library handoff URL next to &le=. Never sends
    // bt=undefined: the Library only records bt when it is present.
    handoffParam: function (data) {
      return BundleTools.hasFlag(data) ? '&bt=' + data.bundle_tools : '';
    },

    // The PictureMaker tile on the account page. Needs a valid Library
    // licence; from the cutover it also needs the Bundle, unless ps_shopify
    // has not said either way.
    showPictureMaker: function (data, now, shop) {
      if (!data || !data.valid) return false;
      if (!BundleTools.cutoverPassed(now, shop)) return true;
      return data.bundle_tools !== false;
    },

    // The DateMaker tile. The Library gates DateMaker on the same
    // User#bundle_tools? as new PictureMaker pictures, so the rule is shared.
    showDateMaker: function (data, now, shop) {
      return BundleTools.showPictureMaker(data, now, shop);
    },

    // The SurveyMaker tile (card 4867). The Library lets in admins and, once
    // its surveys_released switch is on, Bundle customers – the same Bundle
    // rule as PictureMaker. Admin-tagged staff keep the tile whatever /valid
    // says. The theme can't see surveys_released, so publish this with it.
    showSurveyMaker: function (data, isStaff, now, shop) {
      if (isStaff) return true;
      return BundleTools.showPictureMaker(data, now, shop);
    },

    // The "Find out more" PictureMaker and DateMaker tiles (card 5586): shown
    // in place of the real tiles to a valid Library customer who lacks the
    // Bundle, so they learn the tools exist rather than seeing nothing.
    showBundleInfo: function (data, now, shop) {
      if (!data || !data.valid) return false;
      return !BundleTools.showPictureMaker(data, now, shop);
    },

    // The "Find out more" Library, PictureMaker and DateMaker tiles for a
    // customer /valid says has no Library licence – EasyMaker-only, lapsed or
    // new (card 6206). Not a team member: their organisation does the buying.
    showLibraryInfo: function (data, isSubAccount) {
      if (!data || data.valid !== false) return false;
      return !isSubAccount;
    }
  };

  root.BundleTools = BundleTools;
  if (typeof module !== 'undefined' && module.exports) module.exports = BundleTools;
})(typeof window !== 'undefined' ? window : globalThis);
